import React from "react";
import { BrowserRouter } from "react-router-dom";
import { OrderListProvider } from "./presentations/context/OrderListContext";
import AppMessageContext from "./presentations/context/AppMessageContext";
import { AuthProvider } from "./presentations/context/AuthContext";
import { AppItemsProvider } from "./presentations/context/AppItemsContext";
import { AppSaleInfoProvider } from "./presentations/context/AppSaleInfoContext";
import { AppToppingProvider } from "./presentations/context/AppToppingContext";
import { AppReloadProvider } from "./presentations/context/AppReloadContext";
import App from "./App";

const EntryPoint: React.FC = () => {
  return (
    <BrowserRouter>
      <AppMessageContext>
        <AuthProvider>
          <AppItemsProvider>
            <AppToppingProvider>
              <AppSaleInfoProvider>
                <OrderListProvider>
                  <AppReloadProvider>
                    <App />
                  </AppReloadProvider>
                </OrderListProvider>
              </AppSaleInfoProvider>
            </AppToppingProvider>
          </AppItemsProvider>
        </AuthProvider>
      </AppMessageContext>
    </BrowserRouter>
  );
};

export default EntryPoint;
